import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { compareJobsToInvoice, JobsToInvoiceComparison, JobsToInvoiceCompareRequest } from './jobsToInvoiceCompareApi'

export const useJobsToInvoiceCompareMutation = () => {
  return useMutation<JobsToInvoiceComparison, AxiosError, JobsToInvoiceCompareRequest>({
    mutationFn: (request: JobsToInvoiceCompareRequest) => compareJobsToInvoice(request),
  })
}
